import AuthRegister from '@/components/auth/AuthRegister'
import AuthRegisterWithInvitation from '@/components/auth/AuthRegisterWithInvitation'
import AuthActivate from '@/components/auth/AuthActivate'
import AuthLogin from '@/components/auth/AuthLogin'
import AuthLogout from '@/components/auth/AuthLogout'
import AuthPasswordRequest from '@/components/auth/AuthPasswordRequest'
import AuthPasswordRecover from '@/components/auth/AuthPasswordRecover'
import StaticContentUsePolicy from '@/components/statics/StaticContentUsePolicy'
import StaticContentPrivacyPolicy from '@/components/statics/StaticContentPrivacyPolicy'
import StaticContentTerms from '@/components/statics/StaticContentTerms'
import AppShellSimple from '@/components/shell/AppShellSimple'

export default [
	{
		path: '/',
		components: {
			default: AppShellSimple
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'register',
				name: 'AuthRegister',
				components: {
					default: AuthRegister
				}
			},
			{
				path: 'invitation',
				name: 'AuthRegisterWithInvitation',
				components: {
					default: AuthRegisterWithInvitation
				},
				props: {
					default: (route) => ({
						email: route.query.email,
						invitation_id: route.query.invitation
					})
				}
			},
			{
				path: 'activate/:hash',
				name: 'AuthActivate',
				components: {
					default: AuthActivate
				},
				props: {
					default: (route) => ({
						hash: route.params.hash,
					})
				}
			},
			{
				path: 'logout',
				name: 'AuthLogout',
				components: {
					default: AuthLogout
				}
			},
			{
				path: 'password-request',
				name: 'AuthPasswordRequest',
				components: {
					default: AuthPasswordRequest
				}
			},
			{
				path: 'password-recover/:hash',
				name: 'AuthPasswordRecover',
				components: {
					default: AuthPasswordRecover
				},
				props: {
					default: (route) => ({
						hash: route.params.hash,
					})
				}
			},
			{
				path: 'use-policy',
				name: 'AuthStaticContentUsePolicy',
				components: {
					default: StaticContentUsePolicy
				},
				props: {
					default: (route) => ({
						cssprop: 'logged-out',
					})
				}
			},
			{
				path: 'privacy-policy',
				name: 'AuthStaticContentPrivacyPolicy',
				components: {
					default: StaticContentPrivacyPolicy
				},
				props: {
					default: (route) => ({
						cssprop: 'logged-out',
					})
				}
			},
			{
				path: 'privacy-policy',
				name: 'AuthStaticContentPrivacyPolicy',
				components: {
					default: StaticContentPrivacyPolicy
				},
				props: {
					default: (route) => ({
						cssprop: 'logged-out',
					})
				}
			},
			{
				path: 'terms',
				name: 'AuthStaticContentTerms',
				components: {
					default: StaticContentTerms
				},
				props: {
					default: (route) => ({
						cssprop: 'logged-out',
					}),
					menu: true
				}
			},
			{
				path: '',
				name: 'AuthLogin',
				components: {
					default: AuthLogin
				}
			},
		]
	}
]


// WEBPACK FOOTER //
// ./src/router/modules/auth.js